/**
 * Key/value storage for shared code, backed by whatever each app registers.
 *
 * Synchronous because every caller is a selector or a render-path read; mobile
 * therefore mirrors AsyncStorage in memory. A cache, never a source of truth.
 */
// Writes made before a port registers are replayed on registration, so a value
// written during bootstrap is not silently dropped.
const pendingWrites = new Map();
let activePort = null;
export const setStoragePort = (port) => {
    activePort = port;
    for (const [key, value] of pendingWrites) {
        if (value === null)
            port.remove(key);
        else
            port.set(key, value);
    }
    pendingWrites.clear();
};
export const storage = {
    get: (key) => activePort?.get(key) ?? pendingWrites.get(key) ?? null,
    set: (key, value) => {
        if (activePort)
            activePort.set(key, value);
        else
            pendingWrites.set(key, value);
    },
    remove: (key) => {
        if (activePort)
            activePort.remove(key);
        else
            pendingWrites.set(key, null);
    },
    keys: () => activePort
        ? activePort.keys()
        : [...pendingWrites.entries()]
            .filter(([, value]) => value !== null)
            .map(([key]) => key),
};
//# sourceMappingURL=port.js.map